export default {
  english: 'الأنجليزية',
  arabic: 'العربية',
  login: 'تسجيل الدخول',
  cart: 'سلة المشتريات',
  landing: 'الصفحات',
  termsAndDetails: 'قراءة الشروط والتفاصيل'
}
